import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// The Strike AI style template (docs/STRIKE_STYLE.md). Loaded last so it wins.
import './styles/strike.css';
import './styles/strike-colors.css';

// For a before-and-after picture while the restyle is reviewed: ?nostyle shows
// the page as it was. Development builds only.
if (process.env.NODE_ENV !== 'production' && new URLSearchParams(window.location.search).has('nostyle')) {
  for (const s of document.querySelectorAll('style')) {
    if (/strike-style|strike-colors\.js/.test(s.textContent)) s.remove();
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);